import React, { useState } from 'react';
import { CaretDown, CaretUp } from '@phosphor-icons/react';
import './AccordionCard.css';

/**
 * AccordionCard Component
 * A long card with expandable answer content
 */
const AccordionCard = ({ question, answer, defaultOpen = false }) => {
  const [isOpen, setIsOpen] = useState(defaultOpen);

  return (
    <div className={`accordion-card ${isOpen ? 'open' : ''}`}>
      <button 
        className="accordion-card-question" 
        onClick={() => setIsOpen(!isOpen)}
        aria-expanded={isOpen}
      >
        <span className="accordion-card-question-text">{question}</span>
        <span className="accordion-card-toggle">
          {isOpen ? (
            <CaretUp weight="bold" size={20} />
          ) : (
            <CaretDown weight="bold" size={20} />
          )}
        </span>
      </button>
      {isOpen && (
        <div className="accordion-card-answer">
          {answer}
        </div>
      )}
    </div>
  );
};

export default AccordionCard;
